import React, { Component } from "react";
import CloseSqaure from "../../../assets/images/auth/close-square.png";
import MediaImg from "../../../assets/images/auth-home/media-img.png";
import Arrowback from "../../../assets/images/auth/arrow-back.png";

class Media extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: "",
    };
  }

  handleFileChange = (e) => {
    // Update the state
    this.setState({ file: e.target });
    // for showing the image
    var input = e.target;
    var reader = new FileReader();
    reader.onload = () => {
      var dataURL = reader.result;
      var output = document.getElementById("image");
      output.src = dataURL;
    };
    reader.readAsDataURL(input.files[0]);
  };

  handlePublish = () => {
    // alert("Media Published");
    this.props.getMediaData(this.state.file);
    this.props.closeModal();
  };

  render() {
    return (
      <React.Fragment>
        {this.props.width > 768 ? (
          <div className="d-flex justify-content-end">
            <img
              src={CloseSqaure}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={this.props.closeModal}
            />
          </div>
        ) : (
          <div className="row align-items-center">
            <div className="col-5">
              <img src={Arrowback} alt="" onClick={this.props.closeModal} />
            </div>
            <div
              className="col-7 px-0"
              style={{ color: "#181818", fontSize: 18, fontFamily: "Poppins" }}
            >
              Media
            </div>
          </div>
        )}
        <div style={{ marginTop: this.props.width > 992 ? 84 : 48 }}>
          <div className="d-flex justify-content-center pb-3">
            {this.state.file ? (
              <div style={{ height: 200, width: 200 }}>
                <img
                  id="image"
                  alt=""
                  style={{ borderRadius: "50%" }}
                  className="w-100 h-100"
                />
              </div>
            ) : (
              <img src={MediaImg} alt="" />
            )}
          </div>
          <p className="text-center th-auth-popup-media-txt1 mb-0">
            Drag and drop an image, or video.
          </p>
          <p className="text-center th-auth-popup-media-txt2">or</p>
          <div className="d-flex justify-content-center mb-3">
            <label className="btn th-auth-popup-btn3 py-2">
              Browse
              <input
                type="file"
                multiple
                style={{ display: "none" }}
                onChange={this.handleFileChange}
                accept="image/png, image/jpg, image/jpeg, video/mp4, video/webm, video/mkv, video/flv, video/avi"
                placeholder="Upload a photo"
                required
              />
            </label>
          </div>
        </div>
        <div className="d-flex justify-content-md-end justify-content-center th-auth-popup-btn-wraper">
          {this.props.width > 780 && (
            <div
              className="btn th-auth-popup-btn1 mx-2"
              onClick={this.props.closeModal}
            >
              Close
            </div>
          )}
          <div className="btn th-auth-popup-btn2" onClick={this.handlePublish}>
            Continue
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Media;
